import { render, staticRenderFns } from "./PlayerHistoryRating.vue?vue&type=template&id=45556186&scoped=true&"
import script from "./PlayerHistoryRating.vue?vue&type=script&lang=js&"
export * from "./PlayerHistoryRating.vue?vue&type=script&lang=js&"
import style0 from "./PlayerHistoryRating.vue?vue&type=style&index=0&id=45556186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45556186",
  null
  
)

export default component.exports